import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../bottomsheet.module.css";
import clsx from "clsx";
import BottomSheetModal from "../../../BottomSheetModal";
import { useSettingsStore } from "../../../../storage/useSettingsStore";
import Separator from "../../../Separator";
import { ReactComponent as LeftChevron } from "../../../../assets/left-chevron-icon.svg"
import { ReactComponent as SettingsIcon } from "../../../../assets/setting-theme-icon.svg"
import useSettingsBottomsheet from "./useSettingsBottonsheet";

interface SettingsBottomsheetInterface {
  isOpen: boolean;
  onClose: () => void;
  handleLeaveGameClick: () => void;
}

const SettingsBottomsheet: React.FC<SettingsBottomsheetInterface> = ({ isOpen, onClose, handleLeaveGameClick }) => {
  const { t } = useTranslation();
  const { handleMusicToggle, handleSoundToggle, handleVibrationToggle, soundStatus, musicStatus, vibrationStatus } =
  useSettingsBottomsheet()

  const settings = [
    { 
      settingLabel: t("music"),
      state: musicStatus,
      toggle: handleMusicToggle
    },
    { settingLabel: t("soundFX"),
      state: soundStatus,
      toggle: handleSoundToggle
    },
    { settingLabel: t("vibration"),
      state: vibrationStatus,
      toggle: handleVibrationToggle
    },
  ];
  // status={musicStatus} onPress={handleMusicToggle}

  return (
    <BottomSheetModal
      isOpen={isOpen}
      onClose={onClose}
      modalContentClassName={clsx(styles.modalContent, styles.settingModalContent)}
      modalBodyClassName={clsx(styles.modalBody)}
      content={
        <>
          <div className={clsx(styles.modalHeadingContent)}>
            <div className={clsx(styles.modalTitleBlock, styles.prizePoolBlock, "inlineFlex alignItemCenter justifyContentCenter")}>
              <SettingsIcon />
              <span className={clsx(styles.label, "fontWeightBold fontSizeSm14 fontColorLightBlue")}>{t("settings")}</span>
            </div>
          </div>
          <div className={clsx(styles.settingsBlock)}>
            {settings.map(({ settingLabel, state, toggle }, index) => (
              <div
                key={index}
                className={clsx(styles.settingRow, "flex alignItemCenter")}
              >
                <div className={clsx(styles.settingLabel, "fontWeightBold textAlignRight")}>{settingLabel}</div>
                <div className={clsx(styles.switchBox, "flex alignItemCenter")}>
                  <label className={clsx(styles.switch)}>
                    <input type="checkbox" checked={state} onChange={toggle} />
                    <span className={clsx(styles.slider, styles.round, "flex alignItemCenter")}>
                      <span className={clsx(styles.switchLabel, styles.offLabel, "fontWeightBold fontSizeXs")}>{t("off")}</span>
                      <span className={clsx(styles.switchLabel, styles.onLabel, "fontWeightBold fontSizeXs")}>{t("on")}</span>
                    </span>
                  </label>
                </div>
              </div>
            ))}
            <Separator />
            <div className={clsx(styles.exitGame, "flex alignItemCenter justifyContentCenter fontWeightBold fontSizeSm")} onClick={handleLeaveGameClick}>{t("exitGame")} <LeftChevron /></div>
          </div>
        </>
      }
    />
  );
};

export default SettingsBottomsheet;
